module.exports = __webpack_public_path__ + "PSillustration.png?ef496fec8edbef9b71ec2601de4ec0c2";